<template>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onSubmit"
    >
        <v-text-field
            v-model="form.name.value"
            :rules="form.name.rules"
            label="Название"
            name="name"
            required
        ></v-text-field>
        <v-avatar size="70"
                  class="mr-2"
        >
            <img v-if="form.avatar.value" alt="" :src="'/avatars/' + form.avatar.value"/>
        </v-avatar>
        <input name="avatar" type="file" accept="image/jpeg" class="mb-10">
        <v-spacer></v-spacer>
        <v-btn
            :disabled="!valid || isFetch"
            color="success"
            class="mr-4 mt-4 pull-right"
            type="submit"
        >
            Сохранить
        </v-btn>
    </v-form>
</template>
<script>
import * as api from '@/api/workspace';
import {mapActions} from "vuex";
export default {
    name: "WorkSpaceForm",
    props:{
        workspace:{
            type: Object,
            required: false
        }
    },
    mounted() {
        this.reset();
    },
    data() {
        return {
            isFetch: false,
            valid: true,
            form: {
                name:{
                    value: '',
                    rules: [
                        v => !!v || 'Название обязательно к заполнению',
                    ]
                },
                avatar: {
                    value: '',
                }
            },
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_RESPONSE_ERROR']),
        reset(){
            if(this.workspace){
                this.form.name.value = this.workspace.name;
                this.form.avatar.value = this.workspace.avatar;
            }else {
                this.form.name.value = '';
                this.form.avatar.value = '';
            }
        },
        async onSubmit(){
            if( ! this.$refs.form.validate() ){
                return Promise.reject();
            }
            try {
                this.isFetch = true;
                const formData = new FormData(this.$refs.form.$el);
                if(this.workspace){
                    formData.append('_method', 'put')
                    let {data} = await this.onUpdate(formData);
                    this.$emit('updated', data);
                }else {
                    let {data} = await this.onCreate(formData);
                    this.$emit('created', data);
                }
                this.SHOW_SUCCESS('Успешно сохранено');
            }catch (e) {
                console.log(e);
                this.$emit('error', e);
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка сохранения'});
            }finally {
                this.isFetch = false;
            }
        },
        async onUpdate(data){
            return await api.update(this.workspace.id, data);
        },
        async onCreate(form){
            return await api.create(form);
        },
    }
}
</script>
